import API from "../../axiosConfig/axiosConfig"
import { ENDPOINTS } from "../../constants/apiEndPoints"
import { JOURNAL_ANSWERS } from "../types/types"
export const getAllAnswers = () => async (dispatch) => {
  try {
    const res = await API.get(ENDPOINTS.JOURNAL_ANSWERS)
    dispatch({
      type: JOURNAL_ANSWERS,
      payload: res.data,
    })
    return res.data
  } catch (error) {
    console.error("Could not get answers", error)
  }
}

export const saveAnswer = (id, answer) => async (dispatch) => {
  const questionId = `Question${id}`
  const allQuestionsAndAnswers = {}
  allQuestionsAndAnswers[questionId] = answer
  const body = {
    questions: allQuestionsAndAnswers,
  }

  try {
    const res = await API.post(ENDPOINTS.JOURNAL_ANSWERS, body)
    dispatch({
      type: JOURNAL_ANSWERS,
      payload: res.data,
    })
    return res.data
  } catch (error) {
    console.error("Save answer error ", error)
  }
}

export const saveJournalDate = (journalDate) => async (dispatch) => {
  const reqBody = {
    date: journalDate,
  }
  try {
    const res = await API.post(ENDPOINTS.JOURNAL_ANSWERS, reqBody)
  } catch (error) {
    console.error("Save journal date error ", error)
  }
}
